const mutations = {
    CLASS_LOADING: state => {
        state.classtatus = "loading";
    },
    UPDATE_CLASSES: (state, classes) => {
        state.classes = classes;
    },
    CLASS_SUCCESS: (state, data) => {
        state.classtatus = "success";
        Vue.set(state, "classes", data);
        Vue.set(state, "classesCount", data.length);
    },
    CLASS_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.classtatus = "error";
        state.classErrors.record(errors);
    },
    CLEAR_CLASS_ERROR: state => {
        state.classtatus = "";
        state.classErrors.clear();
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
